import { ELayerType } from "./ELayerType";
import { IDataPoint } from "./IDataPoint";
import { IGradientStop } from "@longline/aqua-ui/Types";

/**
 * Which simulation produced a layer. Absent on layers loaded from a system or
 * imported from Excel, which is what distinguishes input data from results.
 *
 * Optional, so `.fins` files written before it existed load unchanged and the
 * version stays at "3" — the same pattern as `IArea.startMonth`.
 */
interface ILayerRun {
  /** Stable identity, so a whole run can be found, hidden or deleted. */
  id: string;
  /** Project-wide ordinal, 1-based. Derived from the layers already present,
   *  so it keeps counting correctly after a project is saved and reopened. */
  index: number;
  /** Name of the area at the time of the run. Areas can be renamed; this is a
   *  snapshot of what was actually simulated. */
  area: string;
  /** ISO timestamp of completion. */
  at: string;
}

interface ILayer {
  source: string;
  run?: ILayerRun;
  type: ELayerType;
  data: IDataPoint[];
  visible: boolean;
  contours: number;
  contourThickness: number;
  gradient: IGradientStop[];

  /** Particle trail length */
  trail: number;
  /** Number of particles on the screen */
  density: number;
  /** Size of individual particles (in pixels) */
  pointSize: number;
  /** Delay factor (0 = no delay) */
  delay: number;
}

/**
 * How a run is named in the UI. Derived rather than stored, so that changing
 * the wording does not need every saved project rewritten.
 */
const runLabel = (run: ILayerRun): string => `${run.area} · run ${run.index}`;

export { ILayer, ILayerRun, runLabel }

